import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal,
  signal,
  WritableSignal,
} from '@angular/core';
import { MatCard, MatCardActions, MatCardHeader, MatCardSubtitle, MatCardTitle } from '@angular/material/card';
import { MatList, MatListItem, MatListItemIcon, MatListItemLine, MatListItemTitle } from '@angular/material/list';
import { ButtonComponent } from '@libs/common/components';
import { IconComponent } from '@libs/components/icons';
import { ProductServiceModel, ShopErrorItemModel } from '@libs/shop/models';

@Component({
  selector: 'ui-order-unavailable-products',
  imports: [
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatCardSubtitle,
    MatCardActions,
    MatList,
    MatListItem,
    MatListItemIcon,
    MatListItemLine,
    MatListItemTitle,
    ButtonComponent,
    IconComponent,

  ],
  templateUrl: './order-unavailable-products.component.html',
  styleUrl: './order-unavailable-products.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderUnavailableProductsComponent {
  public unavailableProductsErrors: InputSignal<ShopErrorItemModel[]> = input.required();
  public loading: InputSignal<boolean> = input(false);
  public showActions: InputSignal<boolean> = input(true);

  public deleteUnavailableProducts: OutputEmitterRef<string[]> = output();

  public showProductList: WritableSignal<boolean> = signal(true);

  public unavailableProducts: Signal<ProductServiceModel[]> = computed(() =>
    this.unavailableProductsErrors()
      .filter(x => Boolean(x.item))
      .map(x => x.item as ProductServiceModel));

  public unavailableProductSkusWithoutData: Signal<string[]> = computed(() =>
    this.unavailableProductsErrors()
      .filter(x => !x.item && x.itemPointer)
      .map(x => x.itemPointer as string));

  public unavailableProductsSkus: Signal<string[]> = computed(() =>
    this.unavailableProductsErrors()
      .filter(x => Boolean(x.itemPointer))
      .map(x => x.itemPointer as string));

  public toggleShowProductList(): void {
    this.showProductList.set(!this.showProductList());
  }
}
